import React from "react";

function ProjectItem({ image, name, gitHub, web}) {

  return (
    <div className="projectItem">

      <div className="front">
        <div style={{ backgroundImage: `url(${image})` }} className="bgImage" />
        <h1> {name} </h1>
      </div>

      <div className="back">
        <a href={gitHub} >gitgub</a>
        <a href={web} >web</a>
      </div>

    </div>
  );
}

export default ProjectItem;
